export enum ReportColumnNames {
    Date = 'date',
    Account = 'account',
    Currency = 'currency',
    Category = 'category',
    Comment = 'comment',
    Debit = 'debit',
    Credit = 'credit',
    Net = 'net',
    Symbol = 'symbol',
    Qty = 'qty',
    CCY = 'ccy',
    AveragePrice = 'avgPrice',
    ClosePrice = 'closePrice',
    BalanceDate = 'balanceDate',
    Cost = 'cost',
    MarketValue = 'marketValue',
    PositionType = 'positionType',
    Unrealized = 'unrealized',
    CLR = 'clr',
    COMM = 'comm',
    Destination = 'destination',
    ECNFee = 'ecnFee',
    IsLess1 = 'isLess1',
    Liquidity = 'liquidity',
    NSCC = 'nscc',
    ORF = 'orf',
    PTFPF = 'ptfpf',
    EFTT = 'eftt',
    CAT = 'cat',
    QuantityBought = 'quantityBought',
    QuantitySold = 'quantitySold',
    RateCLR = 'rateCLR',
    RateComm = 'rateComm',
    RateECN = 'rateECN',
    RateNSCC = 'rateNSCC',
    RateORF = 'rateORF',
    RatePTFPF = 'ratePTFPF',
    RateEftt = 'rateEftt',
    RateCat = 'rateCat',
    RateSEC = 'rateSEC',
    RateTAF = 'rateTAF',
    SEC = 'sec',
    TAF = 'taf',
    ValueBought = 'valueBought',
    ValuePercCLR = 'valuePercCLR',
    ValuePercComm = 'valuePercComm',
    ValuePercECN = 'valuePercECN',
    ValuePercNSCC = 'valuePercNSCC',
    ValuePercORF = 'valuePercORF',
    ValuePercPTFPF = 'valuePercPTFPF',
    ValuePercEftt = 'valuePercEftt',
    ValuePercCat = 'valuePercCat',
    ValuePercSEC = 'valuePercSEC',
    ValuePercTAF = 'valuePercTAF',
    ValueSold = 'valueSold',
    Contra = 'contra',
    Orders = 'orders',
    Fills = 'fills',
    AssetType = 'assetType',
    Gross = 'gross',
    Total = 'total',
    Closed = 'closed',
    Opened = 'opened',
    Held = 'held',
    HeldFormatted = 'heldFormatted',
    Type = 'type',
    Entry = 'entry',
    Exit = 'exit',
    Cash = 'cash',
    Accounts = 'accounts',
    Transfers = 'transfers',
    AdjSum = 'adjSum',
    AdjNet = 'adjNet',
    FillId = 'fillId',
    OrderId = 'orderId',
    Price = 'price',
    Position = 'position',
    Time = 'time',
    Liq = 'liq',
    Route = 'route',
    Typ = 'typ',
    PreviousUnrealized = 'previousUnrealized',
    PreviousCash = 'previousCash',
    Side = 'side',
}
